import {
  Container,
  Title,
  UserInfo,
  Text,
  LogoutContainer,
  LogoutText,
  IconContainer,
  Icon,
} from './styles';

const Info = ({
  name,
  email,
  onLogout,
}) => (
  <Container>
    <Title>
      {`Hello ${name}!`}
    </Title>
    <UserInfo>
      {`${name} / ${email}`}
    </UserInfo>
    <Text>
      To edit your details, change password, manage your current plan, please use your mobile
      app.
    </Text>
    <LogoutContainer onClick={onLogout}>
      <LogoutText>Log out</LogoutText>
      <IconContainer>
        <Icon className="icon-logout" />
      </IconContainer>
    </LogoutContainer>
  </Container>
);

export default Info;
